module.exports = __webpack_public_path__ + "img/2.4_Russian_road_sign.de18fb27.svg";